import AdministracioPedidos from "components-base/pages/administracionpedidos";
export const Pedidos = () =>{
    return(
        <div className="flex w-full flex-col gap-5"><AdministracioPedidos /></div>
    )
}
export default Pedidos;